var _desc, _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHomepageBackground(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "951px",
    height: "591px",
    viewBox: "0 0 951 591",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Pattern") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "97.0128881%",
    y1: "80.0354675%",
    x2: "5.57229857%",
    y2: "95.1971286%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EAF0F4",
    stopOpacity: 0.238252944,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBF0F4",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "43.1430459%",
    y1: "14.5315271%",
    x2: "97.9173155%",
    y2: "81.460417%",
    id: "linearGradient-2"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3DE1D8",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#06B4FB",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "43.1430459%",
    y1: "14.5315271%",
    x2: "97.9173155%",
    y2: "81.460417%",
    id: "linearGradient-3"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1750DA",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#103EAF",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Home",
    transform: "translate(-489.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Pattern",
    transform: "translate(457.000000, -216.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M122.564065,58.5640646 L322.564065,58.5640646 C353.492011,58.5640646 378.564065,83.6361186 378.564065,114.564065 L378.564065,314.564065 C378.564065,349.910289 349.910289,378.564065 314.564065,378.564065 L122.564065,378.564065 C87.2178406,378.564065 58.5640646,349.910289 58.5640646,314.564065 L58.5640646,122.564065 C58.5640646,87.2178406 87.2178406,58.5640646 122.564065,58.5640646 Z",
    id: "Rectangle",
    fill: "url(#linearGradient-1)",
    transform: "translate(218.564065, 218.564065) rotate(-30.000000) translate(-218.564065, -218.564065) "
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "url(#linearGradient-2)",
    transform: "translate(436.844192, 538.844192) rotate(-315.000000) translate(-436.844192, -538.844192) ",
    x: 356.344192,
    y: 458.344192,
    width: 161,
    height: 161,
    rx: 28
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy",
    fill: "url(#linearGradient-3)",
    transform: "translate(997.010562, 546.010562) rotate(-301.000000) translate(-997.010562, -546.010562) ",
    x: 799.510562,
    y: 348.510562,
    width: 395,
    height: 395,
    rx: 28
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomepageBackground);
export default __webpack_public_path__ + "static/media/homepage-background.c2bb00f05a4712dcf6da1f91b84d273f.svg";
export { ForwardRef as ReactComponent };